export const buildForecastReminderPayload = (entry, occurrenceDate, reminderDate) => ({
  forecastId: String(entry.id),
  companyId: entry.companyId || entry.financeCompanyId || null,
  name: entry.name,
  amount: entry.amount,
  description: entry.description || '',
  occurrenceDate,
  reminderDate,
  reminderDaysBefore: Number(entry.reminderDaysBefore || 0),
  recurring: Boolean(entry.recurring),
  recurrenceInterval: entry.recurrenceInterval,
  recurrenceUnit: entry.recurrenceUnit,
  targetUserIds: entry.targetUserIds || [],
  targetSectorIds: entry.targetSectorIds || [],
});

export async function sendForecastReminderFlow({ api, entry, occurrenceDate, reminderDate, formatCurrency, formatDateOnlyLabel }) {
  await api.post('/calendar/events', {
    title: `Lembrete financeiro: ${entry.name}`,
    description: `Valor previsto: ${formatCurrency(entry.amount)}. Vencimento: ${formatDateOnlyLabel(occurrenceDate)}.`,
    date: reminderDate,
    notifyOnDashboard: true,
    sendToAll: false,
    targetUserIds: entry.targetUserIds || [],
    targetSectorIds: entry.targetSectorIds || [],
  });

  return api.post('/finance/forecast-reminders/send', buildForecastReminderPayload(entry, occurrenceDate, reminderDate));
}
